export class DCVenueBookingGuestBC {
  "Id": string;
  "DC Guest Email Id": string = "prakash.poojary@dubaichamber.com";
}

export class DCSRVenueBookingAmenitiesBC {
  "Id": string;
  "DC Amenities": string;
}

export class DCSRVenueBookingCateringTypeBC {
  "Id": string;
  "DC Catering Type": string;
}

export class DCSRVenueBookingRoomImagesBC {
  "Id"?: string;
  "DC Room Image"?: string;
}

export class DCCommunityPortalVenueBookingSR {
  "SR Number": string = "";
  CSN: string = "";
  "SR Type": string = "Venue Booking";
  "Sub Type": string = "Venue Booking";
  "DC Payment Method": string = "Online";
  "DC Channel": string = "Online";
  "DC Venue Booking Title": string;
  "DC Venue Booking Attendees": string;
  "DC Venue Booking Catering Opt": string;
  "DC Venue Booking Start Time": string;
  "DC Venue Booking End Time": string;
  "DC Venue Booking Event Type": string;
  "DC Venue Booking Id": string;
  "DC Venue Booking Location": string;
  "DC Venue Booking Loc Key": string;
  "DC Venue Booking Notes": string;
  "DC Venue Booking Parking Req": string;
  "DC Venue Booking No Of Parking": string;
  "DC Venue Booking Ref Type": string;
  "DC Venue Booking Reminder": string;
  "DC Venue Booking Room": string;
  "DC Venue Booking RoomPrice": number;
  "DC Venue Booking Room Prof Id": string;
  "DC Venue Booking Room Setup": string;
  "DC Venue Booking Room Type": string;
  "DC Venue Booking Email":string;
  "DC Venue Booking Mobile":string;
  "DC Account Holder": string;
  "DC IBAN No": string;
  "DC Venue Booking ProductCode": string;

  "ListOfDC Venue Booking Guest BC" = {
    "DC Venue Booking Guest BC": [
      new DCVenueBookingGuestBC()
    ] as DCVenueBookingGuestBC[]
  };

  "ListOfDC SR Venue Booking Amenities BC" = {
    "DC SR Venue Booking Amenities BC": [
      new DCSRVenueBookingAmenitiesBC()
    ] as DCSRVenueBookingAmenitiesBC[]
  };

  "ListOfDC SR Venue Booking Catering Type BC" = {
    "DC SR Venue Booking Catering Type BC": [
      new DCSRVenueBookingCateringTypeBC()
    ] as DCSRVenueBookingCateringTypeBC[]
  };

  "ListOfDC SR Venue Booking Room Images BC"?: {
    "DC SR Venue Booking Room Images BC": DCSRVenueBookingRoomImagesBC[];
  };
}

export class ListOfDCCommunityPortalSRUpsertIOForVenue {
  "DC Community Portal SR": DCCommunityPortalVenueBookingSR = new DCCommunityPortalVenueBookingSR();
}

export class DCIncomingHierarchyForVenue {
  MessageId: string = "123456";
  IntObjectName: string = "DC Community Portal SR Upsert IO";
  MessageType: string = "Integration Object";
  IntObjectFormat: string = "Siebel Hierarchical";
  "ListOfDC Community Portal SR Upsert IO": ListOfDCCommunityPortalSRUpsertIOForVenue = new ListOfDCCommunityPortalSRUpsertIOForVenue();
}

export class VenueBookingBody {
  ProcessName: string = "DC Community Portal SR Process Wrapper WF";
  DCMethod: string = "SAVEASDRAFT";
  DCLoginName: string = "";
  DCLanguage: string = "";
  DCIncomingHierarchy: DCIncomingHierarchyForVenue = new DCIncomingHierarchyForVenue();
}

export class VenueBookingRequest {
  body: VenueBookingBody = new VenueBookingBody();
}

